import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AgTechWebApplication } from '../../../application/AgTechWebApplication'

const AgTechWebNavigationContext = (props: { app?: AgTechWebApplication, children: JSX.Element }) => {
    return (
        <BrowserRouter basename={props.app?.basePath}>
            {props.children}
        </BrowserRouter>
    )
}

export default React.memo(AgTechWebNavigationContext);